import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {BloggerModalService} from "../services/blogger-modal.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {propertyLazySelectDataProduct} from "../../../../models/property-lazy-select-data";
import {SelectData} from "../../../../types/records-table.types";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {bloggerMassOfferModalName, massOffersFormFields} from "../configs/blogger-mass-offer-modal-config";
import {EditBloggerFormField} from "../types/edit-blogger-modal.types";
import {MassOffersParams} from "../types/blogger-mass-offer-modal.types";

@Component({
  selector: 'app-blogger-mass-offer-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    CdkTextareaAutosize,
    FormsModule,
    MatInput,
    ReactiveFormsModule
  ],
  templateUrl: './blogger-mass-offer-modal.component.html',
  styleUrl: './blogger-mass-offer-modal.component.scss'
})
export class BloggerMassOfferModalComponent extends BaseModalComponent {
  private bloggerMassOfferDialogData = inject<Array<number>>(MAT_DIALOG_DATA);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);

  public readonly massOffersFormFields = massOffersFormFields;
  public massOffersForm: FormGroup = new FormGroup({});
  public productSelectData: Array<SelectData> = [];

  public override async ngOnInit(): Promise<void> {
    this.modalStatesService.openModal(bloggerMassOfferModalName);
    this.initForm();
    await this.getSelectProductData();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(bloggerMassOfferModalName)
  }

  public isDisabledBtn(): boolean {
    return !this.massOffersForm.get('productId' as string)?.value || !this.massOffersForm.get('message' as string)?.value;
  }

  public async handleSendMessage(): Promise<void> {
    const massOfferParams: MassOffersParams = {
      ...this.massOffersForm.value,
      bloggerIds: this.bloggerMassOfferDialogData
    }

    this.loadingService.setIsLoadingState(true);
    await this.bloggerModalService.massOffers(massOfferParams)
      .then(() => this.snackbarService.showMessage({ message: 'Сообщение разослано' }))
      .finally(() => {
        this.loadingService.setIsLoadingState(false);
        this.closeDialog('cancel');
      });
  }

  private initForm(): void {
    const fieldNames: Array<string> = this.massOffersFormFields.map((field: EditBloggerFormField) => field.fieldName);
    this.massOffersForm = this.baseModalService.initForm(fieldNames)
  }

  private async getSelectProductData(): Promise<void> {
    this.productSelectData = await this.bloggerModalService.getSelectData(propertyLazySelectDataProduct).catch(() => []);
  }
}
